import { render, staticRenderFns } from "./variant.vue?vue&type=template&id=13fc3fe8&scoped=true"
import script from "./variant.vue?vue&type=script&lang=js"
export * from "./variant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc3fe8",
  null
  
)

export default component.exports